import api from './api.js'

// Authorized Users Service
export const authorizedUsersService = {
  async getAll() {
    const response = await api.get('/authorized-users')
    return response.data.success ? response.data.data : []
  },

  async getActiveWithEmployee() {
    const response = await api.get('/authorized-users/active-with-employee')
    return response.data.success ? response.data.data : []
  },

  async checkAuthorization(email) {
    const response = await api.get(`/authorized-users/check/${encodeURIComponent(email)}`)
    return response.data.success ? response.data.data : { authorized: false, role: null }
  },

  async create(data) {
    const response = await api.post('/authorized-users', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/authorized-users/${id}`, data)
    return response.data
  },

  async delete(id) {
    const response = await api.delete(`/authorized-users/${id}`)
    return response.data
  }
}

export const adminService = {
  async getDatabaseStats() {
    const response = await api.get('/admin/database/stats')
    return response.data.success ? response.data.data : {}
  },

  async clearTable(table) {
    const response = await api.delete(`/admin/database/${table}`)
    return response.data
  },

  async clearAllData() {
    const response = await api.delete('/admin/database')
    return response.data
  },

  async getTeamPLOverview() {
    const response = await api.get('/admin/team-pl-overview')
    return response.data.success ? response.data.data : []
  }
}

// Top 20 Accounts Service
export const top20AccountsService = {
  async getAll() {
    const response = await api.get('/admin/top20-accounts')
    return response.data.success ? response.data.data : []
  },

  async create(data) {
    const response = await api.post('/admin/top20-accounts', data)
    return response.data
  },

  async delete(id) {
    const response = await api.delete(`/admin/top20-accounts/${id}`)
    return response.data
  }
}

// Budget Service
export const budgetService = {
  async getAll() {
    const response = await api.get('/budget')
    return response.data.success ? response.data.data : []
  },

  async upsert(data) {
    const response = await api.post('/budget', data)
    return response.data
  },

  async delete(id) {
    const response = await api.delete(`/budget/${id}`)
    return response.data
  }
}

// Services (Derden Omzet) Service
export const servicesService = {
  async syncServices() {
    const response = await api.post('/services/sync', {}, { timeout: 600000 })
    return response.data
  },

  async getDerdenOmzet() {
    const response = await api.get('/services/derden-omzet')
    return response.data.success ? response.data.data : null
  }
}
